import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

interface StyledTitleProps {
  theme: any;
  $langPart: any;
}
export const StyledTitle = styled.h1<StyledTitleProps>`
    margin: ${({ theme }) => (theme.card_header_title_centered ? 'auto' : theme.title_margin)};
    ${({ theme }) => theme.card_header_title_hidden && 'display: none'};
    ${({ theme }) => theme.custom_title_missionbiorobotique && theme.custom_title_missionbiorobotique};
    width: ${({ theme, $langPart }) => $langPart && (theme.card_header_title_width ? theme.card_header_title_width : '359px')};

    b {
        ${({ theme }) => theme.card_header_b_color && `color: ${theme.card_header_b_color}`};
        font-weight: 600;
    }

    .type-listitem & {
        ${({ theme }) => theme.list_item_title_weight && `font-weight: ${theme.list_item_title_weight}`};
        ${({ theme }) => theme.custom_listitem_subtitle_alatable && theme.custom_listitem_subtitle_alatable}
        ${({ theme }) => theme.list_item_title_remove_margin_bottom && `margin-bottom: -${pxToRem(18)}`};
    }
`
